module.exports = __webpack_public_path__ + "img/uid-token-game-guide.a4844894.png";